import { Locale } from '../../state/types';

export const getFeatureTranslationKey: (locale: Locale, feature: string) => string = (locale, feature) =>
  `${locale}|${feature}`;
